/** Орб с UnionIcon для стран; `src` — только для банков и прочих сущностей с иконкой. */
import cn from 'classnames';
import {CSSProperties, FC} from 'react';
import styles from './FlagOrb.module.css';
import {UnionIcon} from 'shared/icons';

export type FlagOrbPlaceholder = 'union';

type Props = {
	src?: string;
	alt?: string;
	gradient?: string;
	placeholder?: FlagOrbPlaceholder;
	tone?: 'default' | 'muted';
	className?: string;
};

export const FlagOrb: FC<Props> = ({src, alt = '', gradient, placeholder, tone = 'default', className}) => {
	const style = gradient ? ({['--flag-orb-gradient' as string]: gradient} as CSSProperties) : undefined;
	const isMuted = tone === 'muted';

	if (src) {
		return (
			<span className={cn(styles.flagOrb, styles.flagOrb_image, className)} aria-hidden="true">
				<img className={styles.flagImage} src={src} alt={alt} />
			</span>
		);
	}

	if (placeholder === 'union') {
		const iconOnly = isMuted;

		return (
			<span
				className={cn(styles.flagOrb, isMuted && styles.flagOrb_muted, className)}
				style={iconOnly ? undefined : style}
				aria-hidden="true"
			>
				{iconOnly ? (
					<UnionIcon className={styles.flagSymbol} />
				) : (
					<span className={styles.flagOrbInner}>
						<UnionIcon className={styles.flagSymbol} />
					</span>
				)}
			</span>
		);
	}

	return <span className={cn(styles.flagOrb, styles.flagOrb_stub, className)} aria-hidden="true" />;
};
